import {useApiUpdate} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornDatasource} from "../../../../../application/business/StubbornAsset";

export const useEditionDatasourceUpdate = () => useApiUpdate<StubbornDatasource>(PATH);
